import React from 'react';
import { Page } from 'src/pages/Page';
import { NavigationArrow } from 'src/components/navigation-arrow/NavigationArrow';
import './IntroPage.scss';
import { colorIntToHex } from '../../utils/math';
import ReactSVG from 'react-svg';
import quoteAnchors from './anchor-data/quote';
import { BlobFiller } from '../../components/blob-filler/BlobFiller';

export class IntroPage extends Page {
  // include to not use wobbly line
  componentDidMount() {
  }
  componentWillUnmount() {
  }

  render() {
    const { color, nextUrl } = this.props;
    return (
      <div style={{ background: colorIntToHex(color) }}>
        <div className="Page Intro">
          <div className="Intro-content">
            <div className="Intro-logos">
              <ReactSVG src="./assets/absa-logo.svg" />
              <ReactSVG src="./assets/made-for-humans.svg" />
            </div>
            <div className="Intro-quote">
              <div className="Intro-quoteMark">
                {/* <ReactSVG src="./assets/intro/quotes.svg" /> */}

                <BlobFiller fills={[{
                    anchors: quoteAnchors,
                    x: 0,
                    y: 10,
                    color: 0x500A28,
                    alpha: .3,
                  },
                  {
                    anchors: quoteAnchors,
                    x: 120,
                    y: 10,
                    color: 0x500A28,
                    alpha: .3,
                  }]}
                  isInView={true}
                  width={240} height={200}
                />

              </div>
              <div className="Intro-quoteText">
                We fail more often because we <b>solve the wrong problem</b><br/>than because we get the wrong solution to the <b>right problem</b>.
              </div>
              <div className="Intro-quoteAuthor">
                – Russell L. Ackoff
              </div>
            </div>
          </div>
        </div>
        <div className="Intro-arrow">
          <NavigationArrow color={'#ffffff'} direction="next" url={nextUrl} />
        </div>
      </div>
    );
  }
}
